import { render, staticRenderFns } from "./menusList.vue?vue&type=template&id=6ff3f574&scoped=true"
import script from "./menusList.vue?vue&type=script&lang=js"
export * from "./menusList.vue?vue&type=script&lang=js"
import style0 from "./menusList.vue?vue&type=style&index=0&id=6ff3f574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff3f574",
  null
  
)

export default component.exports